import { RECENT_ACTIVITY_MEMBERSHIP, RECENT_ACTIVITY_MEMBERSHIP_SUCCESS, RECENT_ACTIVITY_MEMBERSHIP_ERROR, RECENT_ACTIVITY_MEMBERSHIP_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const RecentActivityMembership = (state = initialState, action) => {
  switch (action.type) {
    case RECENT_ACTIVITY_MEMBERSHIP:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case RECENT_ACTIVITY_MEMBERSHIP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case RECENT_ACTIVITY_MEMBERSHIP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case RECENT_ACTIVITY_MEMBERSHIP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RecentActivityMembership;
